import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify";

import { deleteOptionDetail } from "../../services/option_detail"

const useDeleteOptionDetail = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteOptionDetail,
        onSuccess: (statusCode) => {
            if (statusCode === 200) {
                queryClient.invalidateQueries({ queryKey: ["question-options"] });
                toast.success("Option deleted successfully!");
            }
        },
        onError: (error: any) => {
            toast.error(error.response?.data?.message);
            throw error;
        }
    })
};

export default useDeleteOptionDetail;
